module.exports = __webpack_public_path__ + "static/media/emissor-b-6.c16f4654.png";